import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Textarea } from "../components/ui/textarea";
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { X} from 'lucide-react';
import { useToast } from "../components/ui/toast-provider";
import { CierreAgenteService } from "../services/cierreAgenteService";

export default function agregarObservacion({ isOpen, onGuardado, onClose, idEditando }: { isOpen: boolean; onGuardado: () => void; onClose: () => void; idEditando: number; }) {

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const [editando, setEditando] = useState(false);

    const { addToast } = useToast();

    const [observacion, setObservacion] = useState("");

    const cargarObservacion = async (id: number) => {
        try {
            setIsLoading(true);
            if(id!=0){
                const response = await CierreAgenteService.getObservacion(id);
                const cierreObservacion = response.data;
                setObservacion(cierreObservacion.comentario)
            }
        } catch (err) {
            console.error("Error al cargar empleados: " + err);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
                await CierreAgenteService.actualizarObservacion(idEditando, {
                    observacion: observacion
                });

            addToast("Observacion agregada exitosamente");
            setObservacion("");
            onGuardado();
        } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al editar";

            setError(message);
        }
    }

    useEffect(() => {
        if(isOpen) {
            setObservacion("");
            if (idEditando !== 0) {
                cargarObservacion(idEditando);
            }
            setEditando(idEditando !== 0);
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }
    return (
        <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
            <div className="rounded-2xl w-full max-w-2xl shadow-lg relative max-h-[90vh] overflow-y-auto scrollbar-thin">
                <Card>
                    <CardHeader className="flex flex-row items-center justify-between">
                        <CardTitle>{'Observación del cierre'}</CardTitle>
                        <button
                        onClick={onClose}
                        className="p-2 hover:bg-destructive/10 rounded-lg transition-colors"
                        >
                        <X className="w-5 h-5 text-destructive" />
                        </button>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                            <span>Observación:</span>
                            <Textarea
                                className="bg-white text-start"
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                            />
                        </div>
                        <div className = "flex justify-center">
                        {error && (
                            <span className="text-destructive text-center text-sm">{error}</span>
                        )}
                        </div>
                        <div className="flex gap-2">
                            <Button type="submit" variant="primary">
                            Agregar Observación
                            </Button>
                            <Button type="button" variant="ghost" onClick={onClose}>
                            Cancelar
                            </Button>
                        </div>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    )

}